import React, { useContext, useMemo } from 'react'

import { DataContext } from '../DataContext'

export default () => {
    const { submit, isSubmitting, facilityID } = useContext(DataContext)

    const buttonDisabled = useMemo(
        () => facilityID == null || isNaN(facilityID),
        [facilityID]
    )

    return (
        <div className="submitButtonWrapper">
            <button
                className={`button is-link ${isSubmitting ? 'is-loading' : ''}`}
                type="button"
                onClick={() => submit()}
                disabled={!!buttonDisabled}
            >
                {`Submit`}
            </button>
        </div>
    )
}
